'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Switch = undefined;

var _systemComponents = require('system-components');

var _systemComponents2 = _interopRequireDefault(_systemComponents);

var _styledSystem = require('styled-system');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Switch = exports.Switch = (0, _systemComponents2.default)({
  role: 'checkbox',
  color: 'blue',
  borderRadius: '99999px'
}, 'space', 'color', function (props) {
  return {
    display: 'inline-flex',
    width: '40px',
    height: '24px',
    backgroundColor: props.checked ? (0, _styledSystem.theme)('colors.' + props.color)(props) : 'transparent',
    boxShadow: 'inset 0 0 0 2px',
    transitionProperty: 'background-color',
    transitionDuration: '.2s',
    transitionTimingFunction: 'ease-out',
    userSelect: 'none',
    '&::after': {
      content: '" "',
      width: '16px',
      height: '16px',
      margin: '4px',
      borderRadius: '99999px',
      transitionProperty: 'transform, color',
      transitionDuration: '.1s',
      transitionTimingFunction: 'ease-out',
      transform: props.checked ? 'translateX(16px)' : 'translateX(0)',
      backgroundColor: props.checked ? (0, _styledSystem.theme)('colors.white')(props) : (0, _styledSystem.theme)('colors.' + props.color)(props)
    }
  };
});

Switch.displayName = 'Switch';

exports.default = Switch;


//////////////////
// WEBPACK FOOTER
// ./~/rebass/dist/Switch.js
// module id = 862
// module chunks = 168707334958949